import React from 'react';
import { Accordion } from './Accordion';
export function Bonuses() {
  const bonuses = [{
    title: '🎁 Bono 1 — Atlas de Adaptaciones Curriculares por Nivel Escolar',
    content: <p data-id="element-19">
          Un atlas completo con adaptaciones específicas para cada nivel
          educativo: inicial, primaria y secundaria. Incluye ejemplos concretos
          por materia y grado, listos para implementar según las necesidades de
          cada alumno.
        </p>
  }, {
    title: '🎁 Bono 2 — Manual de Situaciones Difíciles en el Aula',
    content: <p data-id="element-20">
          Guía práctica con estrategias probadas para manejar las situaciones
          más desafiantes: crisis emocionales, conductas disruptivas, conflictos
          con pares, y más. Incluye protocolos paso a paso y frases modelo.
        </p>
  }, {
    title: '🎁 Bono 3 — Objetivos Pedagógicos Listos para Utilizar',
    content: <p data-id="element-21">
          Banco de objetivos pedagógicos redactados profesionalmente,
          categorizados por área y nivel de complejidad. Ahorrá tiempo en la
          planificación y asegurate de que tus objetivos sean claros, medibles y
          alcanzables.
        </p>
  }, {
    title: '🎁 Bono 4 — Planificador Anual del Acompañante Pedagógico',
    content: <p data-id="element-22">
          Organizá todo tu año laboral: calendario de informes, seguimientos
          mensuales, reuniones programadas, y espacios para notas importantes.
          Mantené el control de todos tus casos en un solo lugar.
        </p>
  }, {
    title: '🎁 Bono 5 — Guía Práctica de TEA, TDAH y Funciones Ejecutivas',
    content: <p data-id="element-23">
          Información actualizada y práctica sobre los diagnósticos más
          frecuentes. Incluye características, estrategias de intervención
          específicas, y recursos visuales para facilitar la comprensión y el
          trabajo diario.
        </p>
  }, {
    title: '🎁 Bono 6 — 50 Estrategias de Intervención para Situaciones Reales',
    content: <p data-id="element-24">
          Cincuenta estrategias concretas y aplicables para las situaciones más
          comunes en el acompañamiento: atención dispersa, dificultades en la
          escritura, problemas de organización, ansiedad ante evaluaciones, y
          más.
        </p>
  }];
  return <section className="w-full bg-gradient-to-b from-yellow-50 to-white py-16 px-4" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <div className="bg-yellow-400 text-gray-900 rounded-lg p-4 mb-8 text-center shadow-lg" data-id="element-27">
          <p className="text-xl md:text-2xl font-bold" data-id="element-28">
            🎁 Además también llevate estos 6 bonos con tu compra GRATIS
          </p>
        </div>

        <Accordion items={bonuses} data-id="element-29" />
      </div>
    </section>;
}